import {useQuery} from "react-query";
import {Client, DisplayNameValue} from "../../../autogenerate/api.generated.clients";

export function useThrowRodLoadTelemetry(frameSerialNumber: string, throwNumber: string) {
    return useQuery<DisplayNameValue[]>(["compressor-throw-rod-load-telemetry", frameSerialNumber, throwNumber], () => new Client().compressor_GetThrowRodLoadTelemetry(frameSerialNumber, throwNumber));
}